// frontend/src/pages/PayrollDrafts/styles.ts
// Palette, type stack, shared style objects, and style factories.

import type { CSSProperties } from "react";

export const FONT = "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif";

export const C = {
  ink: "#12262B",
  inkDark: "#0E1A1A",
  brand: "#15A08C",
  brandDark: "#0F6E56",
  brandBg: "#E1F5EE",
  amber: "#A67312",
  amberBg: "#FEF6E7",
  err: "#DC2626",
  errBg: "#FEE2E2",
  page: "#F4F6F8",
  card: "#FFFFFF",
  line: "#E7EAF0",
  lineSoft: "#F1F3F7",
} as const;

export const TABULAR: CSSProperties = { fontVariantNumeric: "tabular-nums" };

export const outlineBtnStyle: CSSProperties = {
  padding: "6px 12px",
  background: "transparent",
  border: "1.5px solid " + C.ink,
  borderRadius: 8,
  color: C.ink,
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

export const footerBtnStyle: CSSProperties = {
  padding: "12px 18px",
  background: C.card,
  border: "1.5px solid " + C.ink,
  borderRadius: 10,
  color: C.ink,
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
};

export const filterOptionStyle: CSSProperties = {
  padding: "8px 14px",
  fontSize: 13,
  color: C.ink,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontFamily: FONT,
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
};

export const kebabItemStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "9px 12px",
  fontSize: 13,
  color: C.ink,
  cursor: "pointer",
  fontFamily: FONT,
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
};

export const thStyle: CSSProperties = {
  textAlign: "left",
  padding: "12px 10px",
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: C.ink,
  borderBottom: "1px solid " + C.line,
};

export const tdStyle: CSSProperties = {
  padding: "14px 10px",
  color: C.ink,
  fontWeight: 500,
};

export function tabBtnStyle(active: boolean): CSSProperties {
  return {
    padding: "10px 16px",
    fontSize: 14,
    fontWeight: 700,
    color: C.ink,
    background: "transparent",
    border: "none",
    borderBottom: active ? "2px solid " + C.brand : "2px solid transparent",
    marginBottom: -1,
    cursor: "pointer",
    fontFamily: FONT,
    opacity: active ? 1 : 0.7,
  };
}